import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-paper': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M372.6 112.6c39.9-5.6 75.4 25.7 75.4 66.4v131.6c0 12.8-2.3 33.2-5.2 45.7l-30.2 131c-3.3 14.5-16.3 24.8-31.2 24.8h-222.9c-9.1 0-20.8-6-26.1-13.4l-120-168.4c-21.2-29.8-14.8-71.4 14.5-93.2 18.8-13.9 42.1-16.3 62.1-8.9v-126.1c0-44.1 41.1-75.5 82.4-65 23.9-48.2 92.4-50.2 118-0.7 42.5-11.1 83 21.9 83 65.5v10.8zM400 310.6l0-131.6c0-24.9-36.6-25.6-36.6 0.7v76.3c0 8.8-7.2 16-16 16h-6.9c-8.8 0-16-7.2-16-16v-154.2c0-25.5-36.6-26.4-36.6-0.7v154.9c0 8.8-7.2 16-16 16h-6.9c-8.8 0-16-7.2-16-16v-188.3c0-25.5-36.6-26.4-36.6-0.7v189c0 8.8-7.2 16-16 16h-6.9c-8.8 0-16-7.2-16-16v-153.3c0-25.5-36.6-26.3-36.6-0.7v206.5c0 15.6-20 21.9-29 9.3l-27.1-38.1c-14.4-20.2-43.8 2.3-29.4 22.6l115.2 161.7h201.9l27.3-118.6c2.6-11.4 4-23.2 4-34.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-paper.js
// module id = 1762
// module chunks = 0